import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { ExpensesLogisticsUpdateEntity } from "./expenses-logstics-update-entity";
// import {Container} from  




@Entity('expenses')
export class ExpensesLogisticsEntity {
    @PrimaryGeneratedColumn("increment", { name: 'expenses_logistics_id' })
    expensesLogisticsId: number;

    @Column("int", {
        nullable: false,
        name: "sale_order_id"
      })
      saleOrderId: number;

  @Column("int", {
    nullable: false,
    name: "cha_bill"
  })
  chaBill: number;

  @Column("int", {
    nullable: false,
    name: "ocean_frieght"
  })
  oceanFrieght: number;

  
  @Column("int", {
    nullable: false,
    name: "domestic_frieght"
  })
  domesticFrieght: number;

  @Column("int", {
    nullable: false,
    name: "sales_comission"
  })
  salesComission: number;


  @Column("int", {
    nullable: false,
    name: "anti_dumping_duty"
  })
  antiDumpingDuty: number;


  @Column("int", {
    nullable: false,
    name: "cvd"
  })
  cvd: number;

  @Column("int", {
    nullable: false,
    name: "clearing_forwarding"
  })
  clearingForwarding: number;



  @Column("int", {
    nullable: false,
    name: "ddp_transport"
  })
  ddpTransport: number;

  
  @Column("int", {
    nullable: false,
    name: "marine_insurance"
  })
  marineInsurance: number;

  
  @Column("int", {
    nullable: false,
    name: "amc"
  })
  amc: number;

  
  @Column("int", {
    nullable: false,
    name: "duty_drawback"
  })
  dutyDrawback: number;

  
  @Column("int", {
    nullable: false,
    name: "rodtep_amount"
  })
  rodtepAmount: number;

  
  @Column("varchar", {
    nullable: false,
    name: "fda_due_date"
  })
  fdaDueDate: string;

  
  @Column("varchar", {
    nullable: false,
    name: "remarks"
  })
  remarks: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(
    () => ExpensesLogisticsUpdateEntity,
    (update) => update.expensesLogistics
  )
  updates: ExpensesLogisticsUpdateEntity[];
}


